import React from "react";
import { useLang } from "../i18n";
import { PARTNERS } from "../data/content";
import { Marquee } from "../components/fx/Marquee";

export const Partners = () => {
  const { lang } = useLang();
  return (
    <section className="border-y border-white/10 bg-ink py-16">
      <div className="container-pdr">
        <p className="mb-10 text-center font-mono text-xs uppercase tracking-[0.28em] text-white/40">
          {lang === "ro" ? "Parteneri și branduri cu care lucrăm" : "Partners & brands we work with"}
        </p>
      </div>
      <Marquee speed={32}>
        {PARTNERS.concat(PARTNERS).map((p, i) => (
          <span
            key={i}
            className="mx-10 select-none font-display text-3xl font-bold tracking-tight text-white/30 transition-colors duration-300 hover:text-white/80 md:mx-16 md:text-4xl"
          >
            {p}
          </span>
        ))}
      </Marquee>
    </section>
  );
};
